import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';

import Layout from '../Components/Layout';

import EnterTicketTabs from '../Components/Enter/EnterTicketTabs';
import { TicketSamples, TicketEntryBlurb } from 'sg-ui-components';
import UserLockout from '../utils/user_lockout';

const EnterPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    // If we have a prepopulated ticket from the scanner, call the Enter Draw Ticket API and go directly to Post Claim
    // Post Claim will handle all the error reporting to the user if there is any.
    const prepopTicket = new URLSearchParams(document.location.search).get('ticketnumber');
    if (prepopTicket) {
        actions.drawTicketActions.enterDrawTicket({
            ticket_number: prepopTicket,
            entry_method: 'scan',
        });
        return (
            <Redirect
                to={{
                    pathname: '/post-claim',
                    state: { motive: 'ScanTicket' },
                    motive: 'ScanTicket',
                }}
            />
        );
    } else {
        return (
            <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
                <UserLockout>
                    <div className='enter-container container'>
                        <div className='row justify-content-center'>
                            <div className='entry-box col-12 col-lg-6'>
                                <EnterTicketTabs />
                            </div>
                            <div className='entry-box col-12 col-lg-6'>
                                <TicketEntryBlurb {...{ user, cmsSourceFirebase }} />
                            </div>
                        </div>
                        <TicketSamples {...{ config, cmsSourceFirebase }} />
                    </div>
                </UserLockout>
            </Layout>
        );
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EnterPage);
